import { useContainerSize } from "../../../hooks/useContainerSize";
import { MAX_MODAL_HEIGHT } from "../../../utils";
import { ModalProps } from "./Modal";

export const useModalContentHeight = ({
  headerRef,
  footerRef,
  padding = 0,
  gap = 0,
  maxHeight,
}: ModalProps.useModalContentHeightProps) => {
  const { height: headerHeight } = useContainerSize(headerRef);
  const { height: footerHeight } = useContainerSize(footerRef);

  const defaultMaxHeight = window.innerHeight * (MAX_MODAL_HEIGHT / 100); // 90dvh in pixels
  const maxModalHeight = maxHeight ? maxHeight : defaultMaxHeight;

  const maxContentHeight =
    maxModalHeight - headerHeight - footerHeight - padding * 2 - gap * 2;

  return { maxContentHeight };
};
